<i18n src="./resources/crm/history-locales.json"></i18n>

<template>
  <div class="crm-history-container">
    <div v-show="!isLoading" class="inset-fade-effect" :dark="$vuetify.theme.dark" />
    <div v-if="isLoading" class="crm-history-loading">
      <v-progress-linear color="var(--v-accent-base)" indeterminate height="4"></v-progress-linear>
      <div v-once class="text-center pa-5 opacity-75">{{ $t('loading') }}</div>
    </div>
    <div v-else-if="items.length" class="crm-history-content">
      <div class="crm-history-header surface lighten-1">
        <div class="crm-history-search">
          <ecs-search-input :placeholder="$t('searchPlaceholder')" @search-input-changed="handleSearch" />
        </div>
        <div class="crm-history-options">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn class="crm-history-open-btn" color="primary" text small v-on="on" @click="openTableWindow = true">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span v-once>{{ $t('openInNewWindow') }}</span>
          </v-tooltip>
        </div>
      </div>

      <v-dialog v-model="openTableWindow" fullscreen hide-overlay scrollable transition="dialog-bottom-transition">
        <v-card color="surface lighten-1">
          <v-toolbar color="surface lighten-1" dense flat style="max-height: 48px">
            <v-toolbar-title>{{ $t('historyDialogTitle') }}</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn icon @click="openTableWindow = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <InteractionCrmHistoryTable :items="items" :search-text="searchText" vertical-scroll expanded-mode />
          </v-card-text>
        </v-card>
      </v-dialog>

      <InteractionCrmHistoryTable class="crm-history" :items="items" :search-text="searchText" />
    </div>
    <div v-else class="crm-empty-history">
      {{ $t('noInteractionHistory') }}
    </div>
  </div>
</template>

<script>
import InteractionCrmHistoryTable from '@/components/ecs-interaction/InteractionCrmHistoryTable';
import ContactService from '@/services/contactService';

export default {
  name: 'InteractionCrmHistory',

  components: {
    InteractionCrmHistoryTable
  },

  props: {
    contactId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      items: [],
      searchText: '',
      openTableWindow: false,
      isLoading: true
    };
  },

  async mounted() {
    this.items = await this.getContactHistory();
    this.isLoading = false;
  },

  methods: {
    async getContactHistory() {
      let result = [];

      try {
        const response = await ContactService.requestContactInteractionHistory(this.contactId);
        if (response && response.data) {
          result = response.data;
        }
      } catch (error) {
        console.info('Error while retrieving interaction history', error);
      }

      return result;
    },

    handleSearch(searchText) {
      this.searchText = searchText;
    }
  }
};
</script>

<style>
.crm-history-container {
  height: 100%;
  overflow: auto;
}

.crm-history-header {
  display: grid;
  grid-template-columns: auto 36px;
  align-items: start;
  overflow: hidden;
  padding: 8px;
  border-radius: 8px 8px 0 0;
}

.crm-history-content {
  width: 100%;
  padding: 16px;
}

.crm-history-search {
  align-self: center;
}

.crm-history-options {
  align-self: center;
  justify-self: center;
}

.crm-history-open-btn {
  float: right;
  margin: 6px 0;
}

.crm-empty-history {
  border-radius: 8px !important;
  border: 2px dashed;
  padding: 16px;
  text-align: center;
  opacity: 0.5;
  width: 100%;
}
</style>
